import { motion } from "framer-motion";
import { THESIS } from "@/data/content";
import { SectionLabel } from "@/components/site/primitives";

export const Manifesto = () => {
  return (
    <section
      id="thesis"
      data-testid="thesis-section"
      className="mx-auto max-w-[1400px] px-5 md:px-10 py-28 md:py-44"
    >
      <SectionLabel index="[ 01 ]" testId="thesis-label">
        The Investment Thesis
      </SectionLabel>

      <div className="border-t border-epic-line">
        {THESIS.map((item, i) => (
          <motion.div
            key={item.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-12 md:py-20 border-b border-epic-line group"
            data-testid={`thesis-chapter-${item.n}`}
          >
            <div className="md:col-span-3">
              <span className="font-editorial italic text-6xl md:text-8xl text-epic-line transition-colors duration-500 group-hover:text-epic-accent">
                {item.n}
              </span>
            </div>
            <div className="md:col-span-9 max-w-3xl">
              <h3 className="font-grotesk font-bold uppercase tracking-tight text-3xl md:text-5xl text-epic-text mb-5 leading-[0.95]">
                {item.title}
              </h3>
              <p className="font-mono text-sm md:text-base text-epic-sub leading-relaxed">
                {item.body}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
